<template>
  <v-dialog persistent fullscreen v-model="showDlg">
    <v-card height="100%" class="d-flex align-center" style="overflow-x: hidden">
      <v-row>
        <v-col lg="4" offset-lg="4" xs="12">
          <v-card height="400px" outlined>
            <v-card-title>Login</v-card-title>
            <v-divider></v-divider>
            <div class="pa-2">
              <v-text-field label="E-mail" outlined v-model="username" type="username"></v-text-field>
              <v-text-field label="Password" @keyup.enter="doLogin" outlined v-model="password"
                            type="password"></v-text-field>
            </div>

            <v-col cols="12" v-if="errored">
              <v-alert outlined
                       type="error"
                       class="py-1">Login failed, incorrect details or user is not registered.
              </v-alert>
            </v-col>

            <div class="pa-2">
              <v-btn depressed block @click="doLogin"
                     class="mb-2"
                     color="primary">Submit
              </v-btn>
              <v-row>
                <v-col>
                  <v-btn outlined block
                         :to="{name: 'ForgotPassword'}"
                         color="primary">Forgot Password
                  </v-btn>
                </v-col>
                <v-col>
                  <v-btn outlined block
                         :to="{name: 'Register'}"
                         color="primary">Register
                  </v-btn>
                </v-col>
              </v-row>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
import {mapMutations, mapActions} from 'vuex';
import {auth} from 'firebase'


export default {
  name: "Login",

  data() {
    return {
      errored: false,
      showDlg: true,
      isAuthenticating: false,
      username: null,
      password: null
    }
  },

  methods: {
    ...mapMutations(['auth/SET_FIREBASE_TOKEN']),
    ...mapActions('auth',['GET_SESSION_COOKIE']),
    doLogin() {
      this.error = '';
      this.isAuthenticating = true;
      auth().signInWithEmailAndPassword(this.username, this.password).then(({user}) => {
        console.log("LOGGED IN");
        console.dir(user)
        return user.getIdToken().then(idToken => {
          // Session login endpoint is queried and the session cookie is set.
          // CSRF protection should be taken into account.
          console.log("GET COOKIE")
          return this.GET_SESSION_COOKIE(idToken);
        })
      }).then(() => {
        console.log("GO HOME")
        this.isAuthenticating = false;
        this.$router.push({
          name: 'home'
        });
      }).catch((error) => {
        console.dir(error)
        this.errored = true;
        this.isAuthenticating = false;
      });

    }
  }
}
</script>

<style scoped>

</style>
